import { render } from "./Plans.vue?vue&type=template&id=a129683c&scoped=true"
import script from "./Plans.vue?vue&type=script&lang=js"
export * from "./Plans.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-a129683c"

export default script